import { FunctionComponent, Fragment } from 'react'
import { RenderIfProps } from './RenderIf.types'

const RenderIf: FunctionComponent<RenderIfProps> = ({
  condition,
  fallback,
  children,
}) => {
  if (!condition && fallback) {
    return <Fragment>{fallback}</Fragment>
  }

  return condition ? <Fragment>{children}</Fragment> : null
}

export default RenderIf
